import { FeatureFlag, UserRole } from '@synergy/models';

import { AccessControlConnect } from './common/access-control/access-control-connect';
import { AccessControlConnectFeature } from './common/access-control/access-control-connect-feature';
import { AccessControlConnectRole } from './common/components/access-control/access-control-connect-role';
import { PaloBonusSettlementDetail } from './features/bonus-settlements/detail/palo/palo-bonus-settlement-detail';
import { PaloBonusSettlementOverview } from './features/bonus-settlements/overview/palo/palo-bonus-settlement-overview';
import { PaloNotifications } from './features/notifications/palo/palo-notifications';
import { PaloPurchaseOrdersOverview } from './features/purchases-orders/palo/palo-purchase-orders-overview';
import { PaloUserManagementOverview } from './features/user-management/palo/palo-user-management-overview';
import { UserManagementReviewPopup } from './features/user-management/components/review-popup';

const UserManagement = AccessControlConnectRole(UserRole.SupplierAdmin, true)(PaloUserManagementOverview);
const PurchaseOrders = AccessControlConnectFeature(FeatureFlag.PurchaseOrders, true)(PaloPurchaseOrdersOverview);
const UserManagementReviewPopupRestricted = AccessControlConnectRole(
    UserRole.SupplierAdmin,
    false
)(UserManagementReviewPopup);
const Notification = AccessControlConnectRole(UserRole.SupplierAdmin, true)(PaloNotifications);
const BonusSettlementOverviewRestricted = AccessControlConnect(
    [UserRole.SupplierAdmin, UserRole.SupplierBonusContact],
    FeatureFlag.BonusSettlements,
    true
)(PaloBonusSettlementOverview);
const BonusSettlementDetailRestricted = AccessControlConnect(
    [UserRole.SupplierAdmin, UserRole.SupplierBonusContact],
    FeatureFlag.BonusSettlements,
    true
)(PaloBonusSettlementDetail);

export const protectedComponents = {
    UserManagement,
    PurchaseOrders,
    Notification,
    UserManagementReviewPopupRestricted,
    BonusSettlementOverviewRestricted,
    BonusSettlementDetailRestricted,
};
